import React from "react";

import "./AllowLocationManually.scss";
import {
  FunctionWithVoidReturn,
  GenericModalProps,
} from "../../utils/constants/generic-types";
import { OperatingSystems } from "../../utils/vendor";
import { checkOs } from "../../utils/helpers";
import AllowLocationManuallyOnAndroid from "../AllowLocationManuallyOnAndroid/AllowLocationManuallyOnAndroid";
import AllowLocationManuallyOnIos from "../AllowLocationManuallyOnIos/AllowLocationManuallyOnIos";
import { HandleGetDeviceLocationInfo } from "../topup/TopupFlow/types";

interface AllowLocationManuallyProps extends GenericModalProps {
  onOpen: FunctionWithVoidReturn;
  handleDeviceLocationCheck: HandleGetDeviceLocationInfo;
}

export default function AllowLocationManually({
  isOpen,
  onOpen,
  onClose,
  handleDeviceLocationCheck,
}: AllowLocationManuallyProps) {
  const os = checkOs() ?? OperatingSystems.Android;

  if (os === OperatingSystems.Ios) {
    return (
      <AllowLocationManuallyOnIos
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        handleDeviceLocationCheck={handleDeviceLocationCheck}
      />
    );
  }

  return <AllowLocationManuallyOnAndroid isOpen={isOpen} onClose={onClose} />;
}
